import { Button, IconDownload } from '@lessonup/ui-components';
import React, { useState } from 'react';
import { useEditorTranslation } from '../../../../hooks/useEditorTranslation';

interface DownloadLessonByIdProps {
  lessonId: string;
  handleSuccess: () => void;
  handleError: () => void;
  handleExport: (params: {
    lessonId: string;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
    onLoadingChange?: (loading: boolean) => void;
  }) => void;
}

export default function DownloadLessonById({
  lessonId,
  handleSuccess,
  handleError,
  handleExport,
}: DownloadLessonByIdProps) {
  const { t } = useEditorTranslation();
  const [isExporting, setIsExporting] = useState(false);

  return (
    <Button
      buttonShape="rect"
      size="medium"
      buttonType="secondary"
      iconStart={<IconDownload />}
      onClick={() =>
        handleExport({
          lessonId,
          onSuccess: handleSuccess,
          onError: handleError,
          onLoadingChange: setIsExporting,
        })
      }
      disabled={isExporting}
      loading={isExporting}
    >
      {t('shareLessonModal.exportPdf')}
    </Button>
  );
}
